export const TwilioCallErrorWrapper = `flex flex-col h-full p-5`
export const TwilioCallErrorLogoWrapper = `flex flex-col items-center`
export const TwilioCallErrorLogoText = `text-center font-semibold max-w-[290px] md:max-w-full`
export const TwilioCallErrorScript = `m-auto p-10 border rounded-md textl-xl md:text-2xl self-center items-center flex flex-col justify-center text-center`
